var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('app-dasboard'),_c('div',{staticClass:"page-wrapper",staticStyle:{"overflow":"hidden"}},[_c('app-header'),_c('page-guide'),_c('router-view'),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }